enum AbaTypeEnum {
    FinRepaymentPrincipal = 'FIN_REPAYMENT_PRINCIPAL',
    FinSalePrincipal = 'FIN_SALE_PRINCIPAL',
    FitRepaymentPrincipal = 'FIT_REPAYMENT_PRINCIPAL',
    FitSalePrincipal = 'FIT_SALE_PRINCIPAL',
    FnomRepaymentPrincipal = 'FNOM_REPAYMENT_PRINCIPAL',
    FnomSalePrincipal = 'FNOM_SALE_PRINCIPAL',
    Fwt1PrefundPrepaidInterest = 'FWT1_PREFUND_PREPAID_INTEREST',
    Fwt1RepaymentPrincipal = 'FWT1_REPAYMENT_PRINCIPAL',
    Fwt1SellInPrepaidInterest = 'FWT1_SELL_IN_PREPAID_INTEREST',
    Fwt2PrefundPrepaidInterest = 'FWT2_PREFUND_PREPAID_INTEREST',
    Fwt2RepaymentPrincipal = 'FWT2_REPAYMENT_PRINCIPAL',
    Fwt2SellInPrepaidInterest = 'FWT2_SELL_IN_PREPAID_INTEREST',
}

export default AbaTypeEnum;